import React from 'react';
import Logo from '../static/logo.svg';

const LogoIcon = () => (
  <img draggable="false" className="select-none" src={Logo} alt="develooped logo" />
);

export default LogoIcon;
